export const roundToPrecision = (value: number, precision: number) => {
  if (precision > 1) {
    return Math.round(value / precision) * precision;
  } else {
    return Math.round(value * (1 / precision)) / (1 / precision);
  }
};

export const formatToPrecision = (value: number, precision: number) => {
  return roundToPrecision(value, precision).toFixed(
    Math.max(0, Math.ceil(-Math.log10(precision)))
  );
};
